import { render, staticRenderFns } from "./ModalShipmentInfo.vue?vue&type=template&id=0375e21a&"
import script from "./ModalShipmentInfo.vue?vue&type=script&lang=js&"
export * from "./ModalShipmentInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports